exports.onClientEntry = () => {
  // eslint-disable-next-line global-require
  require('core-js/fn/array/find-index');
  // eslint-disable-next-line global-require
  require('core-js/fn/number');
  // eslint-disable-next-line global-require
  require('core-js/fn/object/entries');
  // eslint-disable-next-line global-require
  require('core-js/fn/string/starts-with');
};
